import { Enumeration } from '../enumeration.model';
import { UploadBatchNativeValidationReport } from './upload-batch-native-validation-report.model';
import { UploadBatchValidationStatus } from './upload.model';

export class UploadBatchNativeReport {
    public uploadBatchId: string;
    public uploadBatchType: Enumeration;
    public uploadBatchSource: number;
    public caseTitle: string;
    public uploadBatchTitle: string;
    public uploadedTimestamp: string;
    public userEmail: string;
    public custodian: string;
    public docSource: string;
    public timezone: string;
    public utcOffset: string;
    public docCount: number;
    public unexpandedDocCount: number;
    public expandedDocCount: number;
    public validationStatus: UploadBatchValidationStatus;
    public validationData: UploadBatchNativeValidationReport;
} 